import React from 'react';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function LogDetailViewer(props: any) {
    const { log, evento, trace, info } = props.data || {};

    const parsed = (() => {
        if (!info) return null;
        try {
            return typeof info === 'string' ? JSON.parse(info) : info;
        } catch {
            return info;
        }
    })();

    return (
        <>
            <WindowBody>
                {evento && (
                    <div style={{ marginBottom: 16 }}>
                        <strong>Evento</strong>
                        <p style={{ margin: '4px 0 0', color: '#555' }}>{evento}</p>
                    </div>
                )}

                {log && (
                    <div style={{ marginBottom: 16 }}>
                        <strong>Descrição</strong>
                        <p style={{ margin: '4px 0 0', color: '#555' }}>{log}</p>
                    </div>
                )}

                {trace && (
                    <div style={{ marginBottom: 16 }}>
                        <strong>Trace</strong>
                        <pre style={{
                            margin: '4px 0 0',
                            padding: '10px 12px',
                            background: '#fff3f3',
                            border: '1px solid #f5c6c6',
                            borderRadius: 4,
                            fontSize: 12,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all',
                            maxHeight: 200,
                            overflowY: 'auto',
                        }}>
                            {trace}
                        </pre>
                    </div>
                )}

                {parsed ? (
                    <div>
                        <strong>Info</strong>
                        <pre style={{
                            margin: '4px 0 0',
                            padding: '10px 12px',
                            background: '#f6f8fa',
                            border: '1px solid #e1e4e8',
                            borderRadius: 4,
                            fontSize: 12,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all',
                            maxHeight: 400,
                            overflowY: 'auto',
                        }}>
                            {JSON.stringify(parsed, null, 2)}
                        </pre>
                    </div>
                ) : (
                    !log && !trace && <p style={{ color: '#999' }}>Sem detalhes disponíveis.</p>
                )}
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
}
